"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTime = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const outline_1 = require("@heroicons/react/24/outline");
const calendar_1 = require("primereact/calendar");
const react_1 = require("react");
const InputTime = (props) => {
    const [date, setDate] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (props.value) {
            const updateDate = new Date();
            updateDate.setHours(props.value[0]);
            updateDate.setMinutes(props.value[1]);
            setDate(updateDate);
        }
    }, [props.value]);
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange && event.value !== null && event.value !== undefined) {
            const changeDate = new Date(event.value);
            props.onChange([changeDate.getHours(), changeDate.getMinutes()]);
            setDate(event.value);
        }
        else if (props.onChange) {
            props.onChange(null);
            setDate(null);
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(calendar_1.Calendar, { timeOnly: true, showIcon: true, icon: (0, jsx_runtime_1.jsx)(outline_1.ClockIcon, { className: 'icon-12px' }), className: 'w-full calendar-xs', placeholder: props.placeholder, value: date, onChange: handleChange, invalid: props.invalid }));
};
exports.InputTime = InputTime;
